const api = import.meta.globEager('./**.js')
let apiObj = {}
for (const key in api) {
  if (api[key].default) {
    let name = key.replace(/[^\\\/]*[\\\/]+/g, '')
    let postfix = /\.[^\.]+/.exec(name) //获取文件的后缀
    let text = name.substr(0, postfix['index']) //获取没有后缀的名称
    apiObj[text] = api[key].default
  }
}
export default apiObj
